import { FC } from "react";

import { useSearchParams } from "next/navigation";

import { trpc } from "../../../common/helpers/trpc";

import { TicketingLiveFormEditor } from "./TicketingLiveFormEditor";

import { ContainerLoader } from "@/components/Loaders/ContainerLoader";

export const TicketingLiveFormEditorContainer: FC = () => {
  const searchParams = useSearchParams();
  const query = Object.fromEntries(searchParams.entries());
  const { ticketingId } = query;

  const { data: apiTicketing, isFetching } = trpc.getTicketing.useQuery(
    { ticketingId: ticketingId as string },
    {
      enabled: !!ticketingId && typeof ticketingId === "string",
    }
  );

  const isTicketingClosed = Boolean(
    apiTicketing?.occurrences?.length &&
    apiTicketing.occurrences.every((occurrence) => new Date(occurrence.endUtc) < new Date() || occurrence.closed)
  );

  if (!ticketingId || typeof ticketingId !== "string" || isFetching || !apiTicketing) {
    return <ContainerLoader />;
  }

  return <TicketingLiveFormEditor apiTicketing={apiTicketing} isTicketingClosed={isTicketingClosed} />;
};
